import { DocumentSnapshot } from '@firebase/firestore-types';
import { Pricing } from '../../types/pricing';

export const transformProposal = (proposalRef: DocumentSnapshot): Pricing | null => {
  const data = proposalRef.data();

  if (!data) {
    return null;
  }

  return {
    chargebackHandlingFee: data.chargebackHandlingFee,
    country: data.country,
    creditFee: data.creditFee,
    grade: data.grade,
    merchantDiscountRate: data.merchantDiscountRate,
    paymentMethod: data.paymentMethod,
    payouts: data.payouts,
    region: data.region,
    rollingReserve: data.rollingReserve,
    transactionFee: data.transactionFee,
  };
};
